module.exports = __webpack_public_path__ + "static/media/makinde_adeagbo.a99cc451.jpeg";